import { Component, OnInit, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ti-password-expiration',
  templateUrl: './password-expiration.component.html',
  styleUrls: ['./password-expiration.component.sass'],
})
export class PasswordExpirationComponent implements OnInit {
  strings = tiStrings.auth.passwordReset;
  miscStrings = tiStrings.app.misc;

  close$ = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  closeModal() {
    this.close$.emit();
  }
}
